/* eslint-disable react/jsx-filename-extension */
import React from "react";
import Box from "@mui/system/Box";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import { FormattedMessage } from "react-intl";
import IconNoData2x from "../../../../public/assets/icons/2.0x/IconNoData2";
import IconNoData from "../../../../public/assets/icons/IconNoData";
import { GREY_600 } from "../../../utils/configs/theme/colors";

function NoDataComponent() {
  const matches768 = useMediaQuery("(min-width:768px)");
  return (
    <Box
      style={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        alignItems: "center",
        marginTop: 50,
        marginBottom: 80
      }}
      className="sm:text-start sm:w-screen md:w-full"
    >
      {matches768 ? (
        <div className="">
          <IconNoData2x />
        </div>
      ) : (
        <div className="sm:justify-center">
          <IconNoData />
        </div>
      )}
      <Typography
        gutterBottom
        variant="subtitle2"
        component="p"
        style={{ color: GREY_600, marginTop: 12 }}
        className=""
      >
        <FormattedMessage id="common.dataEmpty" />
      </Typography>
    </Box>
  );
}

export default React.memo(NoDataComponent);
